import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import React, { Suspense } from "react";
import Title from "../GenericComponents/Title";
import "../../styles/tailwind.css";
import { Link } from "react-router-dom";
import { get_ApiManager } from "../ApiManager/ApiManager";
import {
  FaBookReader,
  FaCalendarCheck,
  FaExchangeAlt,
  FaJediOrder,
  FaModx,
  FaPeopleArrows,
  FaPhoenixFramework,
  FaPiedPiperHat,
  FaPlaneDeparture,
  FaSchlix,
  FaStar,
  FaVaadin,
  FaYelp,
} from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import {
  DashboardDualStatCard,
  DashboardExpandToggle,
  DashboardGrid,
  DashboardPageShell,
  DashboardStatCard,
  DashboardStatCardSkeleton,
} from "./dashboardUiShared";

const AppStatusDashboard = React.lazy(() => import("./appStatusDashboard"));

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ausCount: "",
      pakCount: "",
      canadaCount: "",
      ukCount: "",
      userDetail: [],
      totalCount: [],
      userInfo: [],
      eduInfo: [],
      migInfo: [],
      getrfi: "",
      getnoicc: "",
      gettutionCompleted: "",
      getnj: "",
      geteoi: "",
      getroi: "",
      gethealth: "",
      gethealthCompleted: "",
      token: "",
      gettution: "",
      getmigpendinghealth: "",
      getmigcompletedhealth: "",
      getmigpendingbiometric: "",
      getmigcompletedbiometric: "",
      showMore: false,
      allPermissions: getPermissions() || [],
      user: JSON.parse(localStorage.getItem("user_id")) || [],
      branchList: [],
      selectedBranches: [],
      selectedBranch: "null",
      isNew: false,
      website_leads_meta: {},
      compaign_leads_meta: {},
      walkinTotal: 0,
      statsLoading: true,
    };
    this.handleBranchCallback = this.handleBranchCallback.bind(this);
    this.fetchAllWebsiteRegistrations =
      this.fetchAllWebsiteRegistrations.bind(this);
    this.fetchCompaignLeads = this.fetchCompaignLeads.bind(this);
  }
  componentDidMount() {
    this.getTotalApp();
    this.fetchAllWebsiteRegistrations();
    this.fetchCompaignLeads();
    this.fetchWalkinTotal();
  }

  async fetchWalkinTotal() {
    try {
      const response = await apiUrl.get("/walkin-clients/total");
      const total = response.data?.data?.totalClients || 0;
      this.setState({ walkinTotal: total });
    } catch (error) {
      console.error("Failed to fetch walk-in clients total:", error);
      this.setState({ walkinTotal: 0 });
    }
  }

  async fetchAllWebsiteRegistrations() {
    try {
      const resp = await apiUrl.get("all-items-website_registrations");
      if (resp?.data?.data?.items) {
        const metaData = resp.data?.data?.meta;
        this.setState({ website_leads_meta: metaData });
      } else {
        console.warn("No items found in response.");
      }
    } catch (error) {
      console.error("Error fetching website registrations:", error);
    }
  }
  async fetchCompaignLeads() {
    try {
      const resp = await apiUrl.get(`getAllLeads/${this.state.user}`);
      if (resp?.data?.data?.meta) {
        const metaData = resp?.data?.data?.meta;
        this.setState({ compaign_leads_meta: metaData });
      } else {
        console.warn("No items found in response.");
      }
    } catch (error) {
      console.error("Error fetching website registrations:", error);
    }
  }
  async getTotalApp() {
    this.setState({ statsLoading: true });
    const data = "";
    let url = `getTotal`;
    get_ApiManager(
      data,
      url,
      (res) => {
        this.setState({ totalCount: res.data.data, statsLoading: false });
        this.getStatusTotal();
      },
      (err) => {
        this.setState({ statsLoading: false });
        throw err;
      },
    );
  }
  async getStatusTotal() {
    const data = "";
    let url = "showAppTotal";
    get_ApiManager(
      data,
      url,
      (res) => {
        this.setState({
          getrfi: res.data.data["rfi"],
          getnoicc: res.data.data["noicc"],
          getnj: res.data.data["nj"],
          geteoi: res.data.data["eoi-invite-recieve"],
          getroi: res.data.data["roi-invite-recieve"],
          gethealth: res.data.data["health-refund"],
          gettution: res.data.data["tution-fee"],
          gettutionCompleted: res.data.data["tution-completed"],
          gethealthCompleted: res.data.data["health-completed"],
          getmigpendinghealth: res.data.data["mighealthexaminationpending"],
          getmigcompletedhealth: res.data.data["mighealthexaminationcompleted"],
          getmigpendingbiometric: res.data.data["migbiometricspending"],
          getmigcompletedbiometric: res.data.data["migbiometricscompleted"],
        });
      },
      (err) => {
        throw err;
      },
    );
  }

  handleBranchCallback() {
    this.getTotalApp();
  }

  toggleShowMore = () => {
    this.setState((prevState) => ({ showMore: !prevState.showMore }));
  };

  render() {
    const { allPermissions, showMore, totalCount, statsLoading } = this.state;
    const manageTasks = allPermissions["manage_tasks"];
    return (
      <DashboardPageShell>
        <Title
          title="Dashboard"
          singleRowHeader={true}
          tailwindActions={true}
          showBranches={true}
          branchInnerClass={"w-100"}
          showTask={false}
          showMeeting={false}
          showMyTasks={true}
          selectedValues={this.state.selectedBranches}
          parentCallback={this.handleBranchCallback}
          headerExtra={
            <Link
              to={`/employee-attendance/${this.state.user}`}
              className="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-[0.8125rem] font-semibold text-gray-800 no-underline shadow-sm transition hover:border-gray-300 hover:bg-gray-50 whitespace-nowrap"
            >
              <FaCalendarCheck size={14} />
              Attendance details
            </Link>
          }
        />

        <DashboardGrid>
          {statsLoading ? (
            Array.from({ length: 9 }, (_, index) => (
              <DashboardStatCardSkeleton key={`dashboard-sk-${index}`} />
            ))
          ) : (
            <>
          <DashboardStatCard
            title="Walk-in clients"
            value={this.state.walkinTotal}
            icon={FaPeopleArrows}
            primaryTo="/walkin-clients"
            footerLabel="All walk-ins"
            footerValue={this.state.walkinTotal}
            footerTo="/walkin-clients"
            footerEnabled={false}
          />

          {allPermissions["expo-2022"] === 1 && (
            <DashboardStatCard
              title="Website leads"
              value={
                this.state.website_leads_meta.my_assigned ??
                this.state.website_leads_meta.clients
              }
              icon={FaPeopleArrows}
              primaryTo="/my-leads"
              footerLabel="All website leads"
              footerValue={this.state.website_leads_meta.total}
              footerTo="/website-leads"
            />
          )}

          {allPermissions["view_campaign_leads"] === 1 && (
            <DashboardStatCard
              title="Campaign leads"
              value={this.state.compaign_leads_meta?.my_leads}
              icon={FaPeopleArrows}
              primaryTo="/my_leads"
              primaryEnabled={
                allPermissions["view_campaign_leads"] === 1 &&
                allPermissions["edit_campaign_leads"] === 1
              }
              footerLabel="All campaign leads"
              footerValue={this.state.compaign_leads_meta?.total_leads}
              footerTo="/leads"
              footerEnabled={allPermissions["delete_campaign_leads"] === 1}
            />
          )}

          <DashboardStatCard
            title="Processing tasks"
            value={manageTasks ? totalCount["totalTasks"] : totalCount["myTasks"]}
            icon={FaClipboardList}
            primaryTo="/tasks/my-tasks"
            footerLabel="All tasks"
            footerValue={totalCount["totalTasks"]}
            footerTo="/tasks/my-tasks"
            footerEnabled={!!manageTasks}
          />

          <DashboardStatCard
            title="Clients"
            value={totalCount["myAssignedClients"]}
            hint={`Active ${totalCount["myActiveAssignedClients"] ?? "—"} · Inactive ${totalCount["myInactiveAssignedClients"] ?? "—"}`}
            icon={FaPeopleArrows}
            primaryTo="/clients/my-clients"
            footerLabel="All clients"
            footerValue={totalCount["totalClients"]}
            footerTo="/clients/view-clients"
            footerEnabled={!!allPermissions["clients"]}
          />

          <DashboardStatCard
            title="Migration"
            value={totalCount["myMigrations"]}
            hint={`Active ${totalCount["myActiveMigrations"] ?? "—"} · Inactive ${totalCount["myInactiveMigrations"] ?? "—"}`}
            icon={FaPlaneDeparture}
            primaryTo="/view-all/mymig"
            footerLabel="All migration"
            footerValue={totalCount["totalMigrations"]}
            footerTo="/view-all/mig"
            footerEnabled={!!allPermissions["desk_migration"]}
          />

          <DashboardStatCard
            title="Education"
            value={totalCount["myEducations"]}
            hint={`Active ${totalCount["myActiveEducations"] ?? "—"} · Inactive ${totalCount["myInactiveEducations"] ?? "—"}`}
            icon={FaBookReader}
            primaryTo="/view-all/myedu"
            footerLabel="All education"
            footerValue={totalCount["totalEducations"]}
            footerTo="/view-all/edu"
            footerEnabled={!!allPermissions["desk_education"]}
          />

          <DashboardStatCard
            title="Appointments"
            value={totalCount["myAppointments"]}
            icon={FaPhoenixFramework}
            primaryTo="/appointments/view-my-appointments"
            primaryEnabled={!!allPermissions["appointments"]}
            footerLabel="All appointments"
            footerValue={totalCount["totalAppointments"]}
            footerTo="/appointments/view-appointments"
            footerEnabled={!!allPermissions["viewappointments"]}
          />

          <DashboardStatCard
            title="External clients"
            value={totalCount["myExternal"]}
            icon={FaExchangeAlt}
            primaryTo="/external-clients/my"
            footerLabel="All external"
            footerValue={totalCount["totalExternal"]}
            footerTo="/external-clients/total"
            footerEnabled={!!allPermissions["external_clients"]}
            badgeNew={this.state.isNew === true}
          />

          <DashboardStatCard
            title="Follow-ups"
            value={totalCount["myFollowUps"]}
            icon={FaModx}
            primaryTo="/view-all-followups/my"
            footerLabel="All follow-ups"
            footerValue={totalCount["totalFollowUps"]}
            footerTo="/view-all-followups/all"
            footerEnabled={!!allPermissions["all_followups"]}
          />

          <DashboardStatCard
            title="Priority"
            value={totalCount["myPriority"]}
            icon={FaStar}
            primaryTo="/view-priority/my"
            footerLabel="All priority"
            footerValue={totalCount["totalPriority"]}
            footerTo="/view-priority/total"
            footerEnabled={!!allPermissions["all_followups"]}
          />

          {allPermissions["desk_rfi"] === 1 && (
            <DashboardStatCard
              title="RFI"
              value={this.state.getrfi}
              icon={FaJediOrder}
              primaryTo="/view-status-detail/rfi"
              footerLabel="Details"
              footerTo="/view-status-detail/rfi"
            />
          )}

          {allPermissions["desk_noicc"] === 1 && (
            <DashboardStatCard
              title="NOICC"
              value={this.state.getnoicc}
              icon={FaPiedPiperHat}
              primaryTo="/view-status-detail/noicc"
              footerLabel="Details"
              footerTo="/view-status-detail/noicc"
            />
          )}

          {showMore && (
            <>
              {allPermissions["desk_nj"] === 1 && (
                <DashboardStatCard
                  title="Natural justice"
                  value={this.state.getnj}
                  icon={FaSchlix}
                  primaryTo="/view-status-detail/nj"
                  footerLabel="Details"
                  footerTo="/view-status-detail/nj"
                />
              )}

              {(allPermissions["health_examination"] === 1 ||
                allPermissions["health_examination"] === "1") && (
                <DashboardDualStatCard
                  title="Health examination"
                  pending={this.state.getmigpendinghealth}
                  completed={this.state.getmigcompletedhealth}
                  pendingTo="/status-followup/all/mighealthexamination/pending"
                  completedTo="/status-followup/all/mighealthexamination/completed"
                  icon={FaYelp}
                />
              )}

              {(allPermissions["biometrics"] === 1 ||
                allPermissions["biometrics"] === "1") && (
                <DashboardDualStatCard
                  title="Biometrics"
                  pending={this.state.getmigpendingbiometric}
                  completed={this.state.getmigcompletedbiometric}
                  pendingTo="/status-followup/all/migbiometrics/pending"
                  completedTo="/status-followup/all/migbiometrics/completed"
                  icon={FaYelp}
                />
              )}

              {(allPermissions["desk_eoi"] === 1 ||
                allPermissions["desk_eoi"] === "1") && (
                <DashboardStatCard
                  title="EOI invitation"
                  value={this.state.geteoi}
                  icon={FaVaadin}
                  primaryTo="/view-status-detail/eoi"
                  footerLabel="Details"
                  footerTo="/view-status-detail/eoi"
                />
              )}

              {(allPermissions["desk_roi"] === 1 ||
                allPermissions["desk_roi"] === "1") && (
                <DashboardStatCard
                  title="ROI invitation"
                  value={this.state.getroi}
                  icon={FaYelp}
                  primaryTo="/view-status-detail/roi"
                  footerLabel="Details"
                  footerTo="/view-status-detail/roi"
                />
              )}

              <DashboardDualStatCard
                title="Health refund"
                pending={this.state.gethealth}
                completed={this.state.gethealthCompleted}
                pendingTo="/view-status-detail/healthrefund"
                completedTo="/view-status-detail/healthrefundcompleted"
                icon={FaYelp}
              />

              <DashboardDualStatCard
                title="Tuition fee refund"
                pending={this.state.gettution}
                completed={this.state.gettutionCompleted}
                pendingTo="/view-status-detail/tutionrefund"
                completedTo="/view-status-detail/tutionrefundcompleted"
                icon={FaYelp}
              />
            </>
          )}
            </>
          )}
        </DashboardGrid>

        {!statsLoading && (
          <DashboardExpandToggle expanded={showMore} onClick={this.toggleShowMore} />
        )}

        <div className="mt-6">
          <Suspense
            fallback={
              <div className="rounded-xl border border-gray-200 bg-white px-4 py-8 text-center text-sm text-gray-500 shadow-sm">
                Loading charts…
              </div>
            }
          >
            <AppStatusDashboard />
          </Suspense>
        </div>
      </DashboardPageShell>
    );
  }
}

export default Dashboard;
